import { useEffect, useState } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { useLoadingStore } from '../stores/useLoadingStore';
import { Box, LinearProgress } from '@mui/material';
import { memo } from 'react';

function LoadingProgressComponent() {
  const user = useAuthStore(state => state.user);

  const loadProgress = useLoadingStore(state => state.loadProgress);
  const setLoadProgress = useLoadingStore(state => state.setLoadProgress);
  
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimeout;
    let resetTimeout;

    if (loadProgress > 0 && loadProgress < 100) {
      requestAnimationFrame(() => setVisible(true));
    }

    if (loadProgress === 100 || !user) {
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 800); // Espera um pouco para mostrar o 100%

      resetTimeout = setTimeout(() => {
        setLoadProgress(0); // Reseta depois da animação
      }, 1100); // 800ms + 300ms (tempo da transição)

      return () => {
        clearTimeout(hideTimeout);
        clearTimeout(resetTimeout);
      };
    }

    return () => clearTimeout(hideTimeout);
  }, [loadProgress, user, setLoadProgress]);

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 99999,
        transition: 'opacity 0.3s ease',
        opacity: visible ? 1 : 0,
      }}
    >
      <LinearProgress
        variant="determinate"
        value={loadProgress}
        sx={{
          height: 6,
          backgroundColor: 'transparent',
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#5cb85c',
          },
        }}
      />
    </Box>
  );
}

export default memo(LoadingProgressComponent);